var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExercise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.83317C12.705 5.83317 11.6667 6.8715 11.6667 8.1665C11.6667 9.4615 12.705 10.4998 14 10.4998C15.295 10.4998 16.3334 9.4615 16.3334 8.1665C16.3334 6.8715 15.295 5.83317 14 5.83317ZM25.6667 1.1665V6.99984H23.3334V4.6665H4.66671V6.99984H2.33337V1.1665H4.66671V3.49984H23.3334V1.1665H25.6667ZM17.5 13.1365V26.8332H15.1667V20.9998H12.8334V26.8332H10.5V13.1365C8.08504 11.8648 6.41671 9.33317 6.41671 6.4165V5.83317H8.75004V6.4165C8.75004 9.33317 11.0834 11.6665 14 11.6665C16.9167 11.6665 19.25 9.33317 19.25 6.4165V5.83317H21.5834V6.4165C21.5834 9.33317 19.915 11.8648 17.5 13.1365Z",
    fill: "#FFC070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/Exercise.26645086bb2159208e946c35b2fc5b12.svg";
export { ForwardRef as ReactComponent };